"use client"

import { Copy } from "@/app/components/copy/copy"
import { WalletAddress } from "@/app/components/wallet-address"
import {
  ItemDetailsSkeleton,
  ItemDetailsView,
} from "@/app/item/view/item-details-view"
import { ItemCollapsibleInfoCard } from "@/app/item/view/item-info-card"
import {
  formatSolanaCollectionStandardLabel,
  shouldHideSolanaCollectionContractAddress,
} from "@/app/solana/collection-nft-standard"
import { Blockchain } from "@anaconda/core/blockchain/types"
import { Trans } from "@lingui/react/macro"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { useNftReatom } from "../../store/hooks.reatom"
import { getBlockchainLabel } from "./blockchain"
import { CollectionAddress } from "./collection-address"
import { NftRoyaltyReatom } from "./nft-royalty.reatom"
import { getTokenStandardLabel } from "./token-standard"

export function NftDetailsViewReatom() {
  return (
    <ItemCollapsibleInfoCard
      header={<Trans>Details</Trans>}
      content={
        <ErrorBoundary fallback={null}>
          <Suspense fallback={<ItemDetailsSkeleton count={5} />}>
            <NftDetailsContentReatom />
          </Suspense>
        </ErrorBoundary>
      }
    />
  )
}

const NftDetailsContentReatom = reatomComponent(() => {
  const nft = useNftReatom()
  const tokenStandardLabel = getTokenStandardLabel(nft)
  const isSolana = nft.collection.blockchain === Blockchain.SOLANA

  const detailsData = [
    ...(!shouldHideSolanaCollectionContractAddress(nft.collection.type)
      ? [
          {
            title: isSolana ? (
              <Trans>Collection Address</Trans>
            ) : (
              <Trans>Contract Address</Trans>
            ),
            description: <CollectionAddress address={nft.collection.id} />,
          },
        ]
      : []),
    ...(nft.tokenId
      ? [
          {
            title: <Trans>Token ID</Trans>,
            description: <Copy copyValue={nft.tokenId}>{nft.tokenId}</Copy>,
          },
        ]
      : []),
    ...(tokenStandardLabel
      ? [
          {
            title: <Trans>Token Standard</Trans>,
            description: tokenStandardLabel,
          },
        ]
      : []),
    ...(nft.owner
      ? [
          {
            title: <Trans>Owner</Trans>,
            description: <WalletAddress address={nft.owner} />,
          },
        ]
      : []),
    {
      title: <Trans>Chain</Trans>,
      description: getBlockchainLabel(nft.collection.blockchain),
    },
    {
      title: <Trans>Royalty</Trans>,
      description: <NftRoyaltyReatom />,
    },
  ]

  return <ItemDetailsView detailsData={detailsData} />
})
